import { mapState } from "vuex";
import { ReadMoreDirective } from "@/utils/directives";
import { debounce } from "@/utils/functions";


export default {
  name: "Table-parts",
  data() {
    return {
      grouped_by: 'manufacturer',
      showSelected: false,
      search: "",
      groupsPaginated: [],
      groupedPaginated: [],
      perPage: 3,
      currentPage: 1,
    }
  },
  computed: {
    ...mapState({
      skin: state => state.settings.skin,
      group_list: state => state.parts.group_list,
      groups: state => state.parts.groups,
      grouped_by_description: state => state.parts.grouped_by_description,
      partListBasket: state => state.parts.partListBasket
    }),
    totalGroupsPages() {
      return Math.ceil(this.groups.length / this.perPage)
    },
    totalGroupedPages() {
      return Math.ceil(this.grouped_by_description.length / this.perPage)
    },
    headers() {
      return [
        // {
        //   text: this.$i18n.tc("TableResults.Headers.Select"),
        //   value: "select",
        //   align: "center",
        //   sortable: false,
        //   width: "100px",
        //   custom_property: '--header-seleccionar-width'
        // },
        {
          text: "",
          value: "",
          align: "center",
          sortable: false,
          width: "150px",
          custom_property: '--header-thumbnail-width'
        },
        {
          text: this.$i18n.tc("TableResults.Headers.Description"),
          align: "left",
          sortable: false,
          custom_property: '--header-description-width'
        },
        {
          text: this.$i18n.tc("TableResults.Headers.Mfg"),
          align: "center",
          sortable: false,
          custom_property: '--header-mfg-width'
        },
        {
          text: this.$i18n.tc("TableResults.Headers.Part"),
          align: "center",
          sortable: false,
          custom_property: '--header-part-number-width'
        },
        {
          text: this.$i18n.tc("TableResults.Headers.Yrs"),
          align: "center",
          sortable: false,
          custom_property: '--header-years-width'
        },
        {
          text: this.$isDesktopDevice ? this.$i18n.tc("TableResults.Headers.QtyVehicle") : "CANT. POR VEHICULO",
          sortable: false,
          align: "center",
          width: '150px',
          custom_property: '--header-quantity-width'
        }
      ]
    },
    selected_parts() {
      let selected = [{
        name: 'Selected Parts',
        parts: this.partListBasket
      }];
      return selected;
    },
  },
  directives: {
    ReadMore: ReadMoreDirective,
  },
  components: {
    Pagination: () => import("@/components/Table/Pagination.vue")
  },
  methods: {
    switch_group_by() {
      this.grouped_by = this.grouped_by === 'manufacturer' ? 'description' : 'manufacturer';
    },
    update_search_string: debounce(function (new_search_string) {
      console.log("Search string updated:", new_search_string);
      this.search = new_search_string;
      console.log("search 2 ", this.search)
    }, 163),


    getPerPage(page) {
      this.currentPage = page;
      this.groupsPaginated = [];
      let ini = (page * this.perPage) - this.perPage;
      let fin = (page * this.perPage);
      if(this.grouped_by === 'manufacturer')
        this.groupsPaginated = this.groups.slice(ini, fin)
      else
      this.groupedPaginated = this.grouped_by_description.slice(ini, fin)
    },
    getPerPageGrouped(page) {
      this.currentPage = page;
      this.groupedPaginated = [];
      let ini = (page * this.perPage) - this.perPage;
      let fin = (page * this.perPage);
      this.groupedPaginated = this.grouped_by_description.slice(ini, fin)
    },
  },
  mounted() {
    console.log("groups in table", this.groups);
    this.getPerPage(1);
    this.getPerPageGrouped(1);
  }
};